export const mainTheme = {
  space: [0, 6, 12, 18, 24],
  breakpoints: ['48em', '64em', '80em'],
  NavLinkColor: '#ffffff',
  maxWidth: '1280px'
};



// WEBPACK FOOTER //
// ./src/theme.js